import {
  GETTING_CONDITION_QUERIES_FAILED,
  GETTING_CONDITION_QUERY_TEMPLATE_FAILED,
  CREATING_CONDITION_QUERY_TEMPLATE_FAILED,
  UPDATING_CONDITION_QUERY_TEMPLATE_FAILED,
  DELETING_CONDITION_QUERY_FAILED
} from 'store/conditionQueryTemplate/actions';

import { goToButton, dismissButton } from '../../helpers/error/buttonBuilders';
import { CONDITIONQUERIES } from '../UserMessaging/userMessageDomains';

const conditionQuery = {
  [CONDITIONQUERIES]: {
    [GETTING_CONDITION_QUERIES_FAILED]: {
      userMessage: {
        instructions: 'Failed getting all condition queries',
        buttons: [dismissButton()]
      }
    },

    [GETTING_CONDITION_QUERY_TEMPLATE_FAILED]: {
      resource: 'condition-queries',
      userMessage: {
        buttons: [goToButton('OK', '/condition-queries')]
      }
    },

    [UPDATING_CONDITION_QUERY_TEMPLATE_FAILED]: {
      resource: 'condition-queries',
      userMessage: {
        instructions: 'Could not save query, please try again',
        buttons: [dismissButton()]
      }
    },

    [DELETING_CONDITION_QUERY_FAILED]: {
      resource: 'condition-queries',
      userMessage: {
        instructions: 'Could not delete query, please try again',
        buttons: [dismissButton()]
      }
    },

    [CREATING_CONDITION_QUERY_TEMPLATE_FAILED]: {
      resource: 'condition-queries',
      userMessage: {
        instructions: 'Could not save query, please try again',
        buttons: [dismissButton()]
      }
    }
  }
};

export default { ...conditionQuery };